import { render, staticRenderFns } from "./locTypeCascader.vue?vue&type=template&id=1aed7b04&"
import script from "./locTypeCascader.vue?vue&type=script&lang=js&"
export * from "./locTypeCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports